import { render } from "./LineInTheMiddleVertical.vue?vue&type=template&id=40b0b1a0"
import script from "./LineInTheMiddleVertical.vue?vue&type=script&lang=js"
export * from "./LineInTheMiddleVertical.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__